import { SVG, SVGProps } from './svg'

export function IconTriangle(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M22.9 19.63 12.82 2.37a.76.76 0 0 0-.65-.37h-.3a.76.76 0 0 0-.65.37L1.1 19.63a.79.79 0 0 0 0 .76l.14.23c.13.24.38.38.65.38h20.22c.28 0 .53-.14.66-.38l.14-.23a.79.79 0 0 0 0-.76Z" />
    </SVG>
  )
}
